import Enlace from './Enlace'
import RedesSociales from './RedesSociales'
import { marca, navegacion, redes } from '../data/contenido'

function PiePagina() {
  return (
    <footer className="border-t border-oro-profundo/30 bg-carbon">
      {/* El padding inferior suma la safe-area: en iPhone la barra gestual se
          come los últimos ~34px y tapaba el aviso de copyright. */}
      <div className="contenedor py-12 pb-[calc(3rem+env(safe-area-inset-bottom))] sm:py-14 sm:pb-[calc(3.5rem+env(safe-area-inset-bottom))]">
        <div className="flex flex-col gap-8 sm:flex-row sm:items-start sm:justify-between sm:gap-10">
          <div>
            <div className="flex items-center gap-3">
              <img
                src="/logo-icono.webp"
                alt=""
                className="size-[4.5461rem] shrink-0 rounded-full object-contain"
              />
              <p className="font-display text-lg tracking-wide text-marfil">
                Bengalí <span className="text-oro">Leopard Cats</span>
              </p>
            </div>
            <p className="mt-2 max-w-xs text-sm text-marfil-suave/70">
              {marca.eslogan}
            </p>
          </div>

          <nav aria-label="Pie de página">
            {/* min-h-11 da el área táctil de 44px; el gap-y baja a 0 porque
                esa altura ya separa las filas cuando los enlaces envuelven. */}
            <ul className="-my-2 flex flex-wrap gap-x-6 sm:gap-x-8">
              {navegacion.map((item) => (
                <li key={item.href}>
                  <Enlace
                    href={item.href}
                    className="inline-flex min-h-11 items-center text-sm text-marfil-suave transition-colors hover:text-oro-claro"
                  >
                    {item.etiqueta}
                  </Enlace>
                </li>
              ))}
            </ul>
          </nav>

          {/*
            PENDIENTE: perfiles reales de redes sociales y ubicación. El
            array `redes` está vacío a propósito hasta que el cliente los
            confirme; no se inventan cuentas. RedesSociales no renderiza
            nada mientras tanto.
          */}
          <RedesSociales redes={redes} />
        </div>

        <div className="mt-10 flex flex-wrap items-center justify-between gap-x-6 gap-y-3 border-t border-oro-profundo/20 pt-6 sm:mt-12">
          <p className="text-xs text-marfil-suave/70">
            © {new Date().getFullYear()} {marca.nombre}. Todos los derechos
            reservados.
          </p>
          <div className="flex flex-wrap gap-x-6 gap-y-2">
            <Enlace
              href="/entrega-y-garantia"
              className="text-xs text-marfil-suave/70 underline-offset-2 transition-colors hover:text-oro-claro hover:underline"
            >
              Entrega y garantía
            </Enlace>
            <Enlace
              href="/privacidad"
              className="text-xs text-marfil-suave/70 underline-offset-2 transition-colors hover:text-oro-claro hover:underline"
            >
              Aviso de privacidad
            </Enlace>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default PiePagina
